<template>
  <div class="page">
    <Header
      title="顧客台帳"
      :showBack="!isSP || !!id"
      :onHome="onClickBackButton"
      :storeSelectable="isSP"
      @back="onClickBackButton"
    >
      <Button
        v-if="!isCustomerInputVisible && !onlyEdit && !GNAVI_MAINTENANCE"
        class="customer-input"
        icon
        @click="showCustomerInput"
      >
        <AddPeopleIcon />
      </Button>
    </Header>
    <main class="customer" role="main">
      <CustomerList
        v-if="!isSP || !id"
        :searchWord="searchWord"
        :isConditionEnable="condition.isEnable"
        :supplementaryType="condition.supplementaryType"
        :customerList="customerList"
        :isGetCustomerByConditionBusy="isGetCustomerByConditionBusy"
        :isGetCustomerByConditionEnd="isGetCustomerByConditionEnd"
        :selectedCustomerId="selectedCustomerId"
        :isFromReservationList="onlyEdit"
        :heights="customerListHeights"
        @updateSearchWord="updateSearchWord"
        @showConditionModal="conditionModal = true"
        @search="search"
        @next="getCustomerByCondition"
        @selectCustomer="selectCustomer"
      />
      <template v-if="!isSP || id">
        <CustomerDetail
          v-if="!isCustomerInputVisible"
          :busy="detail.busy"
          :isFromReservationList="onlyEdit"
          :heights="historyListHeights"
          :historyToggles="historyToggles"
          :isScrollTop="isScrollTop"
          @editCustomer="editCustomer"
          @deleteCustomer="deleteCustomer"
          @getCustomerImage="getCustomerImageById"
          @getVisitHistory="getVisitHistory"
          @disabledScrollTop="disabledScrollTop"
          @integrated="integrated"
        />
        <CustomerInput
          v-if="isCustomerInputVisible"
          :customer="detail.customer"
          :busy="detail.busy"
          :allOtherAttributes="allAttributes"
          :isCustomerInputVisible="isCustomerInputVisible"
          @saveCustomer="saveCustomerInput"
          @cancelEditCustomer="cancelEditCustomer"
          @deleteCustomerImage="deleteImage"
        />
      </template>
    </main>
    <ConditionModal
      v-if="conditionModal"
      :condition="condition"
      @change="changeCondition"
      @clear="clearCondition"
      @hide="conditionModal = false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AddPeopleIcon from '@/components/icons/addPeople'
import Button from '@/components/atoms/Button'
import Dialog from '@/components/molecules/ModalDialog'
import Header from '@/components/organisms/Header'
import CustomerList from './CustomerList'
import CustomerDetail from './CustomerDetail'
import CustomerInput from './CustomerInput'
import ConditionModal from './modal/ConditionModal'

export default {
  name: 'Top',
  components: {
    AddPeopleIcon,
    Button,
    Header,
    CustomerList,
    CustomerDetail,
    CustomerInput,
    ConditionModal,
  },
  props: {
    id: [Number, String],
    onlyEdit: Boolean,
    backTo: String,
  },
  data() {
    return {
      selectedCustomerId: null,
      customerListHeights: [],
      relationCustomer: null,
      historyListHeights: [],
      historyToggles: [],
      isScrollTop: false,
      conditionModal: false,
      GNAVI_MAINTENANCE,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      detail: state => state.customers.edit,
      searchWord: state => state.customer.searchWord,
      condition: state => state.customer.condition,
      customerList: state => state.customer.customerList,
      isGetCustomerByConditionBusy: state => state.customer.isGetCustomerByConditionBusy,
      isGetCustomerByConditionEnd: state => state.customer.isGetCustomerByConditionEnd,
      isCustomerInputVisible: state => state.customer.isCustomerInputVisible,
    }),
    ...mapGetters({
      allAttributes: 'attributes/all',
    }),
  },
  watch: {
    id(id) {
      this.isScrollTop = true
      if (id === 'new') {
        this.clearCustomerDetail()
        this.clearCustomerInput()
        this.editCustomer()
      } else if (id) {
        this.showMaintenanceModal()
        this.hideCustomerInput()
        this.getCustomerById(id)
      } else {
        this.hideCustomerInput()
        this.clearCustomerDetail()
      }
    },
  },
  mounted() {
    if (this.id === 'new') {
      this.clearCustomerInput()
      this.editCustomer()
    } else if (this.id) {
      this.showMaintenanceModal()
      this.getCustomerById(this.id)
      this.selectedCustomerId = this.id
    }

    const { dispatch } = this.$store
    dispatch('holidays/get')
    dispatch('attributes/get')
    this.getCustomerByCondition()
  },
  methods: {
    async onClickBackButton() {
      if (this.isCustomerInputVisible) {
        if (await Dialog.confirmDispose()) {
          this.clearCustomerInput()
          this.hideCustomerInput()
          this.back()
        }
      } else {
        this.back()
      }
    },
    clearCustomerDetail() {
      this.$store.commit('customers/edit/clear')
      this.$store.commit('customers/detail/visits/clear')
      this.$store.commit('imageMemos/clear')
    },
    clearCustomerList() {
      this.selectedCustomerId = null
      this.customerListHeights = []
      this.$store.commit('customer/updateCustomerListAll', [])
    },
    search() {
      this.clearCustomerList()
      this.updateCondition({ target: 'Start', value: 0 })
      this.getCustomerByCondition()
      this.toList()
    },
    async getCustomerByCondition() {
      await this.$store.dispatch('customer/getCustomerByCondition')
    },
    async selectCustomer(id) {
      if (!this.isCustomerInputVisible || (await Dialog.confirmDispose())) {
        this.hideCustomerInput()
        this.toDetail(id)
      }
      this.selectedCustomerId = id
      this.isScrollTop = true
    },
    getCustomerById(id) {
      const { commit, dispatch } = this.$store
      dispatch('customers/edit/get', id)
      this.historyListHeights = []
      this.historyToggles = []
      commit('customers/detail/visits/clear')
      dispatch('customers/detail/visits/get', id)
      this.getCustomerImageById(id)
    },
    getCustomerImageById(id) {
      const { commit, dispatch } = this.$store
      commit('imageMemos/clear')
      if (!GNAVI_MAINTENANCE) dispatch('imageMemos/get', id)
    },
    updateSearchWord(value) {
      this.$store.commit('customer/updateSearchWord', value)
    },
    updateCondition({ target, value }) {
      this.$store.commit(`customer/updateCondition${target}`, value)
    },
    async changeCondition(condition) {
      const { commit, dispatch } = this.$store
      commit('customer/enableCondition')
      this.clearCustomerList()
      commit('customer/updateCondition', {
        ...condition,
        start: 0,
      })
      await dispatch('customer/getCustomerByCondition')
      this.toList()
      this.conditionModal = false
    },
    async clearCondition() {
      const { commit, dispatch } = this.$store
      commit('customer/clearCondition')
      commit('customer/disableCondition')
      this.clearCustomerList()
      await dispatch('customer/getCustomerByCondition')
      this.toList()
      this.conditionModal = false
    },
    editCustomer() {
      this.$store.commit('customer/showCustomerInput')
    },
    showCustomerInput() {
      this.$router.push({ name: 'CustomerAdd', query: { backTo: this.backTo } })
    },
    hideCustomerInput() {
      this.$store.commit('customer/hideCustomerInput')
    },
    clearCustomerInput() {
      this.$store.commit('customers/edit/reset')
    },
    async saveCustomerInput(isNew) {
      const id = await this.$store.dispatch('customers/edit/save')
      if (!id) return
      if (isNew) {
        this.selectedCustomerId = id
        this.updateSearchWord('')
        this.clearCondition()
      } else if (!this.onlyEdit) {
        // TODO 一覧への反映方法変更
        this.$store.dispatch('customer/updateCustomerOfList', {
          src: this.detail.customer,
          supplementaryType: this.condition.supplementaryType,
        })
      }

      // 削除したidを持ち続けているのでリセット
      this.$store.commit('customers/edit/update', { deleteImageIds: [] })
      this.toDetail(id)
      this.getCustomerById(id)
      this.hideCustomerInput()
    },
    async cancelEditCustomer() {
      if (await Dialog.confirmDispose()) {
        this.clearCustomerInput()
        this.hideCustomerInput()

        // SP版は顧客新規追加キャンセル後に常に一覧へ遷移
        if ((!this.isSP || this.id !== 'new') && this.selectedCustomerId) {
          if (this.id === this.selectedCustomerId) this.getCustomerImageById(this.selectedCustomerId)
          this.selectCustomer(this.selectedCustomerId)
        } else {
          this.toList()
        }
      }
    },
    async deleteCustomer() {
      if (
        await Dialog.confirm({
          title: '確認',
          message: '選択している顧客情報を\n削除してもよろしいですか？',
          okText: 'はい',
          cancelText: 'キャンセル',
          caution: true,
        })
      ) {
        if (await this.$store.dispatch('customers/edit/delete')) {
          this.updateSearchWord('')
          this.clearCondition()
          this.toList()
        }
      }
    },
    async deleteImage(id) {
      if (
        await Dialog.confirm({
          title: '登録中の写真を削除します',
          message: '削除してよろしいでしょうか？',
          okText: '削除',
          cancelText: '戻る',
          caution: true,
        })
      ) {
        this.$store.commit('imageMemos/delete', id)
        this.$store.commit('customers/edit/update', {
          deleteImageIds: this.detail.customer.deleteImageIds.concat([id]),
        })
      }
    },
    integrated(id) {
      this.clearCondition()
      this.toDetail(id)
      this.getCustomerById(id)
    },
    toList() {
      this.$router.replace({ name: 'Customers', query: { backTo: this.backTo } })
    },
    toDetail(id) {
      this.$router.push({
        name: 'CustomerDetail',
        params: { id, onlyEdit: this.onlyEdit },
        query: { backTo: this.backTo },
      })
    },
    back() {
      if (this.isSP) {
        this.$router.push(this.backTo)
      } else {
        location.href = this.backTo
      }
    },
    getVisitHistory(customerId) {
      this.$store.dispatch('customers/detail/visits/get', customerId)
    },
    disabledScrollTop() {
      this.isScrollTop = false
    },
    showMaintenanceModal() {
      if (GNAVI_MAINTENANCE) {
        Dialog.show({
          title: 'ご注意',
          message:
            'ただいま「ぐるなびネット予約」がメンテナンス中につき、こちらの操作は行えません。\nメンテナンス解除まで、今しばらくお待ちください。\nメンテナンスの詳細についてはお知らせをご確認ください。',
          okText: '閉じる',
        })
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.customer {
  display: grid;
  flex: 1;
  grid-template-columns: 400px 1fr;
  overflow: hidden;

  .sp & {
    grid-template-columns: auto;
  }
}
</style>
